import { useState } from "react";

export default function useLocalStorage() {
  const getLocalStorage = () => {
    const s1 = localStorage.getItem("UserName");
    const s2 = localStorage.getItem("Tenant");
    return { userName: s1, tenant: s2 };
  };

  const [ls, setLs] = useState(getLocalStorage());
  const saveLocalStorage = ({ UserName, Tenant }) => {
    localStorage.setItem("UserName", UserName);
    localStorage.setItem("Tenant", Tenant);

    setLs({ userName: UserName, tenant: Tenant });
  };

  return {
    setLs: saveLocalStorage,
    ls,
  };
}
